import { Tooltip } from 'reactstrap';
import { Button as ReactButton } from 'reactstrap';
import { Button as CustomButton } from '@shoflo/polymer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const StyledButton = styled(CustomButton)`
  padding: 0.4375rem 1rem !important;
  border: ${props =>
    props['color'] === 'outline' && '1px solid #BEC5D3'}!important;
  background-color: ${props =>
    props['color'] === 'outline' && '#FFFFFF'}!important;
  color: ${props => props['color'] === 'outline' && '#BEC5D3'}!important;
  cursor: ${props => props.disabled && 'not-allowed'};
  &:disabled {
    opacity: ${props => props.opacity / 100}!important;
    border: none;
  }
  ${props =>
    props.color === 'danger' &&
    props.confirmClick &&
    `
        background-color: #9B2012 !important;
        box-shadow: none!important;
      `}
`;

export const TransparentElement = styled.span`
  width: 180px;
  height: 40px;
  display: ${props =>
    props['show-popover'] === 'true' ? 'block' : 'none'}!important;
  position: absolute;
  z-index: 9999999;
  cursor: not-allowed;
`;

export const StyledTooltip = styled(Tooltip)`
  & .tooltip-inner {
    text-align: left;
  }
`;

export const StreamingPopOver = styled.div`
  padding: 15px;
  background: #ffffff;
  box-shadow: 0 2px 12px -2px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  display: flex;
  align-items: center;
  position: absolute;
  font-size: 87.5%;
  z-index: 999999999;
`;

export const StreamingPopOverText = styled.span`
  padding-right: 20px;
`;

export const LinkButton = styled(ReactButton)`
  color: #33373d;
  margin-left: 5px;
  &:hover {
    color: #000000;
  }
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  font-size: 16px !important;
`;

export const StyledStreamVerb = styled.span`
  padding: 0 6px;
`;
